<mat-sidenav-container class="dashboard-container">
  <mat-sidenav mode="side" opened>
    <app-webiat-drawer></app-webiat-drawer>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
